import { IBasicControlPublicProps, IBasicControlDefinition, IControlProps, IRuntimeControlProps } from "./types";
import forBasicControl from "./forBasicControl";
import React from "react";

interface ICustomControlProps extends IBasicControlPublicProps<any, IBasicControlDefinition> {
    render: React.ComponentType<IControlProps<any, IBasicControlDefinition>>;
}
export const CustomControl: React.FunctionComponent<ICustomControlProps & IRuntimeControlProps> = (props) => {
    const Control = forBasicControl(props.render);

    return <Control {...props} />;
};
